import {
  collection,
  deleteDoc,
  doc,
  getCountFromServer,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  setDoc,
  startAfter,
  where,
} from 'firebase/firestore';
import { firebaseApp } from './config';
import { LogType } from '../interfaces/LogType';
import { getCurrentUserId } from './auth-helper';
import { createSettingsItem, loadSettings } from './db-settings';
import { FilterType } from '../interfaces/FilterType';

const db = getFirestore(firebaseApp);

function createItem(data: any) {
  const item: LogType = {
    logId: data.logId,
    logNr: data.logNr ? data.logNr : -1,
    logCreated: data.logCreated
      ? data.logCreated
      : new Date('2000-01-01').toISOString(),
    pilotId: data.pilotId ? data.pilotId : '',
    isPractice: data.isPractice ? data.isPractice : '',
    observerId: data.observerId ? data.observerId : '',
    analystId: data.analystId ? data.analystId : '',
    location: data.location ? data.location : '',
    mission: data.mission ? data.mission : 'Übung',
    crash: data.crash ? data.crash : false,
    flightType: data.flightType ? data.flightType : 'BVLOS',
    droneType: data.droneType,
    comment: data.comment ? data.comment : '',
    userLastEdits: data.userLastEdits ? data.userLastEdits : [],
    startTime: data.startTime,
    endTime: data.endTime,
    flyTime: data.flyTime,
    maxAllowedHeight: data.maxAllowedHeight,
    heightMax: data.heightMax,
    xSpeedMax: data.xSpeedMax,
    ySpeedMax: data.ySpeedMax,
    zSpeedMax: data.zSpeedMax,
    errors: {
      waveError: data.errors.waveError,
      isMotorBlocked: data.errors.isMotorBlocked,
      motorStartFailedCause: data.errors.motorStartFailedCause,
      isAcceletorOverRange: data.errors.isAcceletorOverRange,
      isBarometerDeadInAir: data.errors.isBarometerDeadInAir,
      isCompassError: data.errors.isCompassError,
      isNotEnoughForce: data.errors.isNotEnoughForce,
      isPropellerCatapult: data.errors.isPropellerCatapult,
      isVibrating: data.errors.isVibrating,
      isStuck: data.errors.isStuck,
    },
    battery: {
      chargeLevelStart: data.battery.chargeLevelStart,
      chargeLevelEnd: data.battery.chargeLevelEnd,
      current: data.battery.current,
      minTemperature: data.battery.minTemperature,
      maxTemperature: data.battery.maxTemperature,
    },
    flight: data.flight,
    interval: data.interval,
    weatherData: data.weatherData ? data.weatherData : undefined
  };
  return item;
}
export async function getUniqueLessonID(): Promise<string> {
  const randomId = Math.round(Math.random() * 999999999) + '';
  const courseFound = await loadLog(randomId); //Todo
  if (courseFound) {
    return getUniqueLessonID();
  }
  return randomId;
}

export async function loadLog(logId: string): Promise<LogType | undefined> {
  console.log('loadLog');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return undefined;
  }
  const q = query(
    collection(db, 'users', uid, 'logs'),
    where('logId', '==', logId)
  );
  const querySnapshot = await getDocs(q);
  let result = undefined;
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    console.log('Log found: ' + logId);
    result = createItem(data);
  });
  return result;
}
export async function loadSnapshot(logId: string) {
  console.log('loadSnapshot');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return undefined;
  }
  const settings = await loadSettings();
  let zugriffscode: string | undefined = undefined;
  if (settings == undefined) {
    return [];
  } else {
    const zugangscode = settings.zugangscode;
    if (settings.zugangscode != createSettingsItem({}).zugangscode) {
      console.log('Zugriffscode gefunden');
      zugriffscode = zugangscode;
    }
  }
  const q = query(
    collection(db, 'users', zugriffscode ? zugriffscode : uid, 'logs'),
    where('logId', '==', logId)
  );
  const querySnapshot = await getDocs(q);
  var data;
  querySnapshot.forEach((doc) => {
    data = doc;
  });
  return data;
}

export async function saveLogs(logs: LogType[]) {
  console.log('saveLogs');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return;
  }
  const settings = await loadSettings();
  let zugriffscode: string | undefined = undefined;
  if (settings == undefined) {
    return [];
  } else {
    const zugangscode = settings.zugangscode;
    if (settings.zugangscode != createSettingsItem({}).zugangscode) {
      console.log('Zugriffscode gefunden');
      zugriffscode = zugangscode;
    }
  }
  logs.forEach((item) => {
    const ref = doc(
      db,
      'users',
      zugriffscode ? zugriffscode : uid,
      'logs',
      item.logId
    );
    setDoc(ref, item);
  });
}

export async function deleteLogById(id: string): Promise<boolean> {
  console.log('deleteLogById');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return false;
  }
  try {
    const ref = doc(db, 'users', uid, 'logs', id);
    await deleteDoc(ref);
    return true;
  } catch (e) {
    return false;
  }
}

export async function loadLogs(
  pageSize: number = 10,
  lastLog: LogType | undefined,
  includes: FilterType[]
) {
  try {
    console.log('Load logs2');
    const uid = getCurrentUserId();
    if (!uid) return;

    const settings = await loadSettings();
    let zugriffscode: string | undefined = undefined;
    if (settings == undefined) {
      return [];
    } else {
      const zugangscode = settings.zugangscode;
      if (settings.zugangscode != createSettingsItem({}).zugangscode) {
        console.log('Zugriffscode gefunden');
        zugriffscode = zugangscode;
      }
    }
    let q = query(
      collection(db, 'users', zugriffscode ? zugriffscode : uid, 'logs'),
      orderBy('startTime', 'desc')
    );
    console.log(includes);
    for (let i = 0; i < includes.length; i++) {
      const { field, operator, value } = includes[i];
      q = query(q, where(field, operator, value));
    }
    console.log(lastLog);
    if (lastLog) {
      const lastDoc = await loadSnapshot(lastLog.logId);
      console.log(lastDoc);
      q = query(q, startAfter(lastDoc));
    }
    q = query(q, limit(pageSize));
    console.log(q);
    const querySnapshot = await getDocs(q);
    const newLogs: LogType[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      newLogs.push(createItem(data));
    });
    console.log('Loaded ' + newLogs.length + ' items');
    return newLogs;
  } catch (error) {
    console.error('Fehler beim Laden der Logs:', error);
  }
}

export async function getLogCount(includes: FilterType[]) {
  try {
    console.log('getLogCount');
    const uid = getCurrentUserId();
    if (!uid) return 0;

    const settings = await loadSettings();
    let zugriffscode: string | undefined = undefined;
    if (settings == undefined) {
      return 0;
    } else {
      const zugangscode = settings.zugangscode;
      if (settings.zugangscode != createSettingsItem({}).zugangscode) {
        console.log('Zugriffscode gefunden');
        zugriffscode = zugangscode;
      }
    }
    let q = query(
      collection(db, 'users', zugriffscode ? zugriffscode : uid, 'logs')
    );

    for (let i = 0; i < includes.length; i++) {
      const { field, operator, value } = includes[i];
      q = query(q, where(field, operator, value));
    }
    const snapshot = await getCountFromServer(q);
    const count = snapshot.data().count;
    return count;
  } catch (error) {
    console.error('Fehler beim Laden der Logs:', error);
    return 0;
  }
}
